
import { defineComponent, onBeforeMount, PropType, reactive, toRaw } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

// types
import { FeedbackStatusT } from '@/core/types/vacancies.types'

// enums
import { FeedbackStatusesT } from '@/core/enums/vacancies.enums'

// constants
const FeedbackStatuses: FeedbackStatusT[] = [
    { id: 1, name: 'Создано', code: FeedbackStatusesT.CREATED },
    { id: 2, name: 'Просмотрено', code: FeedbackStatusesT.VIEWED },
    { id: 3, name: 'Нужно подумать', code: FeedbackStatusesT.BETHINKED },
    { id: 4, name: 'Не подходит', code: FeedbackStatusesT.CANCELED },
]

// validations
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// composable
import useHelpers from '@/common/composable/useHelpers'

export default defineComponent({
    components: {
        modal: Modal,
        'the-select': TheSelect,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        initialValue: {
            type: Object as PropType<{ status_id: number; feedback_index: number }>,
            default: null,
        },
    },
    emits: ['cancel', 'change-status'],
    setup(props, { emit }) {
        const state = reactive({
            status_id: null as number | null,
            feedback_index: null as number | null,
        })

        const state_form$ = useVuelidate({ status_id: required }, state)

        const { findItemIndexById } = useHelpers()

        onBeforeMount(() => {
            if (!props.initialValue) return
            state.status_id = props.initialValue.status_id
            state.feedback_index = props.initialValue.feedback_index
        })

        const emitCancel = () => {
            emit('cancel')
        }

        const emitChangeStatus = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            const status = FeedbackStatuses.find(
                (status: FeedbackStatusT) => status.id === state.status_id
            )
            if (!status) return

            emit('change-status', {
                status,
                feedback_index: state.feedback_index,
            })
        }

        return { FeedbackStatuses, state, state_form$, emitCancel, emitChangeStatus }
    },
})
